import { render, staticRenderFns } from "./ReqDeletion.vue?vue&type=template&id=8e7777f8&"
import script from "./ReqDeletion.vue?vue&type=script&lang=js&"
export * from "./ReqDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports